<div class="booking__footer">
  <div class="booking__footer__inner">
    <span (click)="closeBooking()">Avbryt bokning</span>
  </div>
</div>
